var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t('reporting.routeKPIs')))]),_c('DataTable',{attrs:{"values":_vm.routesData,"rows":[
      { name: _vm.$t('reporting.kpi.route'), slot: 'route' },
      { name: _vm.$t('reporting.kpi.groups'), slot: 'stopsCount', style: 'align-right' },
      { name: _vm.$t('reporting.kpi.containers'), slot: 'containersCount', style: 'align-right' },
      {
        name: _vm.$t('reporting.kpi.emptiedContainers'),
        slot: 'emptiedContainersCount',
        style: 'align-right',
      },
      { name: _vm.$t('reporting.kpi.fillLevelAvg'), slot: 'averageFillLevel', style: 'align-right' },
      { name: _vm.$t('reporting.kpi.overflows'), slot: 'overflowsCount', style: 'align-right' },
      { name: _vm.$t('reporting.kpi.notifications'), slot: 'notificationsCount', style: 'align-right' } ],"layoutFixed":false},scopedSlots:_vm._u([{key:"route",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(value.name)+" ")]}},{key:"stopsCount",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(value.stops_count)+" ")]}},{key:"containersCount",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(value.containers_count)+" ")]}},{key:"emptiedContainersCount",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(value.emptied_containers_count)+" "),_c('span',[_vm._v("("+_vm._s(value.containers_count ? ((value.emptied_containers_count / value.containers_count) * 100).toFixed(1) : 0)+" "),_c('span',[_vm._v("%")]),_vm._v(")")])]}},{key:"averageFillLevel",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s((value.average_fill_level * 100).toFixed(1))+" "),_c('span',[_vm._v("%")])]}},{key:"overflowsCount",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(value.overflows_count)+" ")]}},{key:"notificationsCount",fn:function(ref){
    var value = ref.value;
return [_vm._v(" "+_vm._s(value.notifications_count)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }